import React, { useEffect } from "react";
import {
  Box,
  ChevronUp,
  EyeOff,
  Mail,
  Phone,
  RotateCcw,
  Shield,
  Slash,
  Tool,
  Trash2,
} from "feather-icons-react/build/IconComponents";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
//import { setToogleHeader } from "../../../core/redux/action";
import SettingsSideBar from "../settingssidebar";
import { RootState, useAppDispatch, useAppSelector } from "../../../../core/redux/store";
import { getProfile } from "../../../../core/redux/apis/auth";

const SecuritySettings: React.FC = () => {
 
    const dispatch = useAppDispatch();
  
  
    const toggleHeader = useAppSelector((state: any) => state.toggle_header);
    // const selectedUser = useAppSelector(
    //   (state: any) => state.userSettings.selectedUser
    // );
   // const { selectedUser } = useAppSelector((state) => state.auth);
    const { user: selectedUser } = useAppSelector((state) => state.auth);
    useEffect(() => {
    dispatch(getProfile() as any);
  }, [dispatch]);
  console.log("Selected User:", selectedUser);

  // ✅ Typed selector
  //const data = useSelector((state: RootState) => state.toggle_header);

  // ✅ Typed tooltip renderer
  const renderRefreshTooltip = (props: any) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  const renderCollapseTooltip = (props: any) => (
    <Tooltip id="collapse-tooltip" {...props}>
      Collapse
    </Tooltip>
  );
  const formatDate = (dateString?: string) => {
  if (!dateString) return "Not available";

  const date = new Date(dateString);

  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

  return (
    <div className="page-wrapper">
      <div className="content settings-content">
        <div className="page-header settings-pg-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Settings</h4>
              <h6>Manage your settings on portal</h6>
            </div>
          </div>

          <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                <Link to="#">
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>

            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  to="#"
                  id="collapse-header"
                 // className={data ? "active" : ""}
                 // onClick={() => dispatch(setToogleHeader(!data))}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <div className="settings-wrapper d-flex">
              <SettingsSideBar />

              <div className="settings-page-wrap">
                <div className="setting-title">
                  <h4>Security</h4>
                </div>

                <div className="security-settings">
                  <ul>
                    {/* Password */}
                    <li>
                      <div className="security-type">
                        <span className="security-icon">
                          <EyeOff />
                        </span>
                        <div className="security-title">
                          <h5>Password</h5>
                          {/* <p>Last Changed 22 July 2023, 10:30 AM</p> */}
                          <p>
  Last Changed {formatDate(selectedUser?.lastLogin || selectedUser?.updatedAt)}
</p>
                        </div>
                      </div>

                      <div className="security-btn">
                        <Link to="#" className="btn btn-primary">
                          Change Password
                        </Link>
                      </div>
                    </li>

                    {/* Two Factor */}
                    {/* <li>
                      <div className="security-type">
                        <span className="security-icon">
                          <Shield />
                        </span>
                        <div className="security-title">
                          <h5>Two Factor</h5>
                          <p>
                            Receive codes via SMS or email every time you login
                          </p>
                        </div>
                      </div>

                      <div className="security-btn d-flex align-items-center">
                        <Link to="#" className="btn btn-danger">
                          Disable
                        </Link>

                        <div className="status-toggle modal-status ms-2">
                          <input
                            type="checkbox"
                            id="user3"
                            className="check"
                            defaultChecked={true}
                          />
                          <label htmlFor="user3" className="checktoggle" />
                        </div>
                      </div>
                    </li> */}

                    {/* Phone */}
                    <li>
                      <div className="security-type">
                        <span className="security-icon">
                          <Phone />
                        </span>
                        <div className="security-title">
                          <h5>Phone Number Verification</h5>
                          <p>Verified Mobile Number : {selectedUser?.phone ?? "No phone number"}</p>
                        </div>
                      </div>

                      <div className="security-btn d-flex align-items-center">
                        <Link to="#" className="btn btn-primary">
                          Change
                        </Link>
                        <Link to="#" className="remove-red ms-2">
                          Remove
                        </Link>
                      </div>
                    </li>

                    {/* Email */}
                    <li>
                      <div className="security-type">
                        <span className="security-icon">
                          <Mail />
                        </span>
                        <div className="security-title">
                          <h5>Email Verification</h5>
                          <p>Verified Email :  {selectedUser?.email ?? "No email"}</p>
                        </div>
                      </div>

                      <div className="security-btn d-flex align-items-center">
                        <Link to="#" className="btn btn-primary">
                          Change
                        </Link>
                        <Link to="#" className="remove-red ms-2">
                          Remove
                        </Link>
                      </div>
                    </li>

                    {/* Delete */}
                    {/* <li>
                      <div className="security-type">
                        <span className="security-icon">
                          <Trash2 />
                        </span>
                        <div className="security-title">
                          <h5>Delete Account</h5>
                          <p>Last Changed 26 July 2023, 11:40 AM</p>
                        </div>
                      </div>

                      <div className="security-btn">
                        <Link to="#" className="btn btn-danger">
                          Delete
                        </Link>
                      </div>
                    </li> */}
                  </ul>
                </div>
              </div>
              {/* /settings-page-wrap */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecuritySettings;